module.exports = __webpack_public_path__ + "img/title8.0221d1cc.png";